import { TableCell, TableHead, TableRow } from "@mui/material";

import STRINGS from "../../utils/strings";

export default function ProviderHoursTableHead() {
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: "60%" }}>
          {STRINGS.COLUMN_HEADER[1]}
        </TableCell>
        <TableCell sx={{ width: "35%" }}>
          {STRINGS.COLUMN_HEADER[2]}
        </TableCell>
        <TableCell sx={{ width: "5%" }} />
      </TableRow>
    </TableHead>
  );
}
